import catalogCollectionBuilderEvents from 'modules/catalog/collectionBuilder/segment';
import catalogCollectionsEvents from 'modules/catalog/collections/segment';
import catalogUploadFormEvents from 'modules/catalogForm/segment';
import catalogEditorEvents from 'modules/catalogTable/segment';
import * as notificationCenterActions from 'modules/notificationCenter/actionTypes';
import { selectNotificationCenterFilters } from 'modules/notificationCenter/selectors';
import organizationEvents from 'modules/organization/segment';
import { templateIndexSegmentEvents } from 'modules/templateIndex/utils/segment';
import templatePickerEvents from 'modules/templatePicker/ducks/segment';
import { FIRE_SEGMENT_TRACK_CALL, TEST_FIRE_SEGMENT_TRACK_CALL } from './actionTypes';

const PAGE = 'page';
const TRACK = 'track';

export default {
  '@@router/LOCATION_CHANGE': {
    event: PAGE,
    eventKeys: [],
  },
  [notificationCenterActions.FETCH_NOTIFICATIONS_RESPONSE]: {
    event: TRACK,
    eventName: 'NotificationCenter/Fetch Notifications',
    eventKeys: ['isFilterUpdate', 'notifications'],
    eventDetailsFormatter: (event, state) => ({
      isFilterUpdate: event.isFilterUpdate,
      notificationLength: event.notifications.length,
      filters: selectNotificationCenterFilters(state),
    }),
  },
  [notificationCenterActions.UPDATE_NOTIFICATIONS_REQUEST]: {
    event: TRACK,
    eventName: 'NotificationCenter/Update Notifications',
    eventKeys: ['notifications', 'isAllReadRequest'],
  },
  [FIRE_SEGMENT_TRACK_CALL]: {
    event: TRACK,
    eventNameFormatter: (event) => event.eventName,
    eventDetailsFormatter: (event) => ({ ...event.eventProperties }),
  },
  [TEST_FIRE_SEGMENT_TRACK_CALL]: {
    event: TRACK,
    eventNameFormatter: (event) => event.eventName,
    eventDetailsFormatter: (event) => ({ ...event.eventProperties }),
    shouldTrackEvent: () => false,
  },
  ...catalogCollectionsEvents,
  ...catalogCollectionBuilderEvents,
  ...catalogEditorEvents,
  ...catalogUploadFormEvents,
  ...organizationEvents,
  ...templatePickerEvents,
  ...templateIndexSegmentEvents,
};
